import { Logo } from "../Logo/Logo";
import { Button } from "../buttons/Button/Button";
import goodFace from "../../images/icons/GoodfaceLogo.svg";
import "./footer.css";

export const Footer = () => {
  return (
    <div className="container">
      <div className="footer">
        <div className="footer-upper-section">
          <div>
            <div className="logo">
              <Logo />
            </div>
            <p className="description-medium">
              Ensuring safer harvests
              <br /> in an unsafer environment.
            </p>
          </div>
          <div className="company-data-wrapper">
            <div className="company-information">
              <div>
                <p className="body1">Company</p>
                <a href="/#" className="button-text">
                  ABOUT US
                </a>
                <a href="/#" className="button-text">
                  RESEARCH, NEWS & EVENTS
                </a>
                <a href="/#" className="button-text">
                  CAREER
                </a>
                <a href="/#" className="button-text">
                  CONTACTS
                </a>
              </div>
              <div>
                <p className="body1">Products</p>
                <a href="/#" className="button-text">
                  ORGANIC LINE
                </a>
                <a href="/#" className="button-text">
                  WUXAL
                </a>
                <a href="/#" className="button-text">
                  PERTIPLANT
                </a>
                <a href="/#" className="button-text">
                  UNIFERX
                </a>
              </div>
              <div>
                <p className="body1">Resources</p>
                <a href="/#" className="button-text">
                  CROP NUTRITION PROGRAMS
                </a>
                <a href="/#" className="button-text">
                  TRIAL RESULTS
                </a>
                <a href="/#" className="button-text">
                  INFORMATION MATERIALS
                </a>
              </div>
            </div>
            <div className="footer-contacts">
              <div>
                <p className="body1">Social media</p>
                <div>
                  <Button type="instagram" />
                  <Button type="facebook" />
                  <Button type="youtube" />
                </div>
              </div>
              <div>
                <p className="body1">Contacts</p>
                <a href="mailto:info@uniferx.com" className="button-text mail">
                  INFO@UNIFERX.COM
                </a>
                <a href="tel:+380443344700" className="button-text phone">
                  +38 044 33 44 700
                </a>
                <a href="/#" className="button-text map-pin">
                  81 TURGENEVSKA St., KYIV, OFFICE. 1-А
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-lower-section">
          <p className="body1 copyright">Copyright © UniferX 2023</p>
          <div className="policies">
            <a href="/#" className="button-text">
              TERMS & CONDITIONS
            </a>
            <a href="/#" className="button-text">
              LEGAL INFO
            </a>
            <a href="/#" className="button-text">
              COOKIE POLICY
            </a>
            <a href="/#" className="button-text">
              ANONYMOUS FEEDBACK
            </a>
          </div>
          <p className="goodface-bar">
            <span className="body1">Created by</span>{" "}
            <span className="goodface">
              <a href="https://goodface.agency" target="blank">
                Goodface
                <img src={goodFace} alt="Goodface logo" />
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
